import React from 'react';
import styled from 'styled-components';

import PrimaryCloseControl from '../common-components/PrimaryCloseControl';
import * as CatizColors from './Colors';
import WindowHeader from './WindowHeader';

const Container = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
`;
const PrimaryHookContainer = styled.div`
  border-right: solid 5px gray;
  position: relative;
`;
const SecondaryHookContainer = styled.div`
  position: relative;
`;

const MsgButton = styled.button`
  position: absolute;
  right: 10px;
  top: 24px;
  ${CatizColors.grayFont};
  padding: 0px 15px;
  border-radius: 10px;
  background-color: ${CatizColors.blue};
`;

const HookImageContainer = styled.div`
  text-align: center;
  margin-bottom: 8px;
  margin-top: 4px;
  > img {
    height: 16px;
    width: 16px;
    margin-top: 5px;
  }
`;

export default function HooksPanel() {
  return (
    <Container>
      <PrimaryHookContainer>
        <WindowHeader name={'Primary CC'} />
        <HookImageContainer>
          <img src={require('../../assets/images/primaryHookIcon.png')} />
          <MsgButton>Msg</MsgButton>
          <PrimaryCloseControl isPrimary />
        </HookImageContainer>
      </PrimaryHookContainer>
      <SecondaryHookContainer>
        <WindowHeader name={'Secondary CC'} />
        <HookImageContainer>
          <img src={require('../../assets/images/secondaryHookIcon.png')} />
          <PrimaryCloseControl isSecondary />
          <MsgButton>Msg</MsgButton>
        </HookImageContainer>
      </SecondaryHookContainer>
    </Container>
  );
}
